module.exports = __webpack_public_path__ + "img/visa_mastercard_mada.f00b11ad.png";